<ng-container *ngIf="isLoading; else pageContent">
  <div class="app-spinner">
    <mat-spinner></mat-spinner>
  </div>
</ng-container>

<ng-template #pageContent>
  <div class="container-fluid">
    <div class="row">
      <div class="header-row sticky-header">
        <div class="text-start ms-3"><span>Notifications</span></div>
        <div class="text-end">
          <span (click)="close()">
            <img src="assets/images/close_button.svg" alt="cancel" />
          </span>
        </div>
      </div>

      <div class="all-row mb-3 ms-3">
        <span class="all-text"> {{ source === 'notifications' ? 'All' :'Recent'}}</span>
        <span class="count-badge" (click)="markAllNotificationsAsRead()">{{ totalNotificationCount }}</span>
      </div>

	  <ng-container *ngIf="studentNotifications.length > 0 ; else noNotifications">
      <div class="notifications-scrollable">
        <div
          *ngFor="let notification of studentNotifications"
          class="notification-card mb-3"
          [ngClass]="{ unread: !notification.is_read, read: notification.is_read}">
          <div class="icon-box ms-2">
            <span *ngIf="!notification.is_read" class="unread-dot"></span>
            <mat-icon
              *ngIf="notification.content_type === notificationTypeEnum.Announcement">campaign</mat-icon>
            
			  <mat-icon
              *ngIf="notification.content_type === notificationTypeEnum.Course">menu_book</mat-icon>
            
			  <mat-icon
              *ngIf="notification.content_type === notificationTypeEnum.Quiz">quiz</mat-icon>

          </div>

          <div class="content-box">
            <div class="title">{{ notification.teacher_name }}</div>
            <div class="subtitle">{{ notification.title }}</div>

            <button
              class="btn-add p-2" 
			  *ngIf="notification.content_type === notificationTypeEnum.Announcement"
              (click)="goToAnnouncementPage(notification.class_id)">
              View Announcement
            </button>

            <button
              class="btn-add p-2"
              *ngIf="notification.content_type === notificationTypeEnum.Course"
              (click)="goToCourseDetailPage(notification.class_id,notification.content_id)">
              View Course
            </button>

            <button
              class="btn-add p-2"
              *ngIf="notification.content_type === notificationTypeEnum.Quiz"
              (click)="goToQuizPage(notification.class_id)">
              View Quiz
            </button>
          </div>

          <div class="meta-box">
            <span class="time">{{ notification.created_at | istDate }}</span>
            <img
              src="assets/images/delete.svg"
              alt="delete"
              (click)="openDeleteNotificationBox(notification.id)" />
          </div>
        </div>
      </div>
     </ng-container>
	 <ng-template #noNotifications>
     <div class="no-notifications text-start p-4">
      <p>No notifications found</p>
    </div>
	 </ng-template>
    </div>
  </div>
</ng-template>